import { IAppState } from '../../common/state';

export const selectIsMortgageRateHikeBannerClosed = (state: IAppState): boolean =>
  Boolean(state.isMortgageRateHikeBannerClosed);
